@if (visible()) {
	<!-- قدرت خرید گواهی سپرده rides above the tabs on every screen that carries the
		footer — «نوار ثابت پایین صفحات اصلی» in the handoff. -->
	<app-wallet-buying-power-bar />

	<!-- Above the قدرت خرید scrim: it dims the page, not the footer. -->
	<nav class="relative z-1001 grid grid-cols-5 border-t-stroke-050 border-t w-full h-14 bg-gray-000">
		@for (menu of menuItems; track menu.route) {
			<a
				[routerLink]="menu.route"
				[class]="`flex flex-col items-center justify-center gap-1 text-3.25 p-1 ${selectedMenuClass(menu)}`">
				<ui-icon [iconName]="getMenuIcon(menu)" />
				<span>{{ menu.title }}</span>
			</a>
		}
	</nav>
}
